<template>
  <!-- 用户流水控制-新用户范围控制 -->
  <div>
    <el-dialog
      :visible.sync="showMark"
      :close-on-click-modal="false"
      :title="'新用户范围控制'"
      width="350px"
      @close="closeDialog"
    >
      <el-form
        ref="dataFrom"
        v-if="dataFrom"
        :model="dataFrom"
        label-width="110px"
        :rules="dataRules"
        v-loading="loading"
      >
        <el-form-item prop="recharge" label="充值金额">
          <el-input v-model="dataFrom.recharge"></el-input>
        </el-form-item>
        <el-form-item prop="open_box" label="开箱金额">
          <el-input v-model="dataFrom.open_box"></el-input>
        </el-form-item>
        <el-form-item prop="rate" label="抽奖开箱比例">
          <el-input v-model="dataFrom.rate"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
export default {
  components: {},
  props: {
    value: {
      type: Object,
      default: undefined
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false, //弹窗加载动画
      buttonLoading: false, //按钮加载动画
      dataFrom: {
        recharge: undefined,
        open_box: undefined,
        rate: undefined
      },
      dataRules: {//表单验证
        recharge: [
          {
            required: true,
            message: '请输入充值金额',
            trigger: 'blur'
          }
        ],
        open_box: [
          {
            required: true,
            message: '请输入开箱金额',
            trigger: 'blur'
          }
        ],
        rate: [
          {
            required: true,
            message: '请输入抽奖开箱比例',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  computed: {
    showMark: { //显示标志
      get() {
        return this.visible
      },
      set() { }
    },
    dialogInfo: { //传来的数据
      get() {
        return this.value
      },
      set() { }
    }
  },
  watch: {
    showMark(val) {
      if (val) {
        this.getData()//拿取数据
      }
    }
  },
  created() {

  },
  methods: {
    getData() {
      //获取表单数据
      this.loading = true
      getApiData('new_user_configs').then(res => {
        if (res) {
          this.dataFrom = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    submit() {
      //保存编辑好的表单信息

      this.$refs['dataFrom'].validate((valid) => {
        if (valid) {
          if (this.dataFrom.rate >= 1 || this.dataFrom.rate <= 0) {
            this.$message.warning("抽奖开箱比例必须在0-1之间")
            return
          }

          this.buttonLoading = true
          let params = this.dataFrom
          patchApiData('new_user_configs ', params)
            .then(res => {
              this.$message.success("保存成功！")
              this.closeDialog() //关闭弹窗
            })
            .finally(() => {
              this.buttonLoading = false
            })
        }
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit('close')
      this.dataFrom = {
        recharge: undefined,
        open_box: undefined,
        rate: undefined
      }
    },
  }
}

</script>
<style lang="less" scoped>
.btn-box {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>
